import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Logo from "./assets/logo.png";
import Fecha from "./assets/fecha.png";
import Title from "./assets/title.png";
import Arrow from "./assets/arrow.png";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";

const schema = yup
  .object()
  .shape({
    names: yup.string().max(150).required(),
    dni: yup.string().max(8).required(),
    email: yup.string().email().max(100).required(),
    phone: yup.string().max(12).required(),
    company: yup.string().max(100).required()
  })
  .required();

function App() {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (data) => {
    if (!errors.name || !errors.dni || !errors.email || !errors.phone || !errors.company) {
      postUser(data);
    }
  };

  const [isLoading, setLoading] = useState(false);

  const postUser = async (data) => {
    setLoading(true);
    const response = await fetch(
      "https://geodisapi.coelumtech.com/api/register",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    const data_response = await response.json();
    if (data_response?.success) {
      Swal.fire({
        title: "Usuario registrado con éxito!",
        icon: "success",
        showCloseButton: false,
        confirmButtonColor: "#4940E5",
      }).then((result) => {
        setLoading(false);
        reset({
          names: "",
          dni: "",
          email: "",
          phone: "",
          company: ""
        });
      });
    } else {
      setLoading(false);
      Swal.fire({
        title: "Hubo un problema con el registro",
        icon: "error",
        showCloseButton: false,
        confirmButtonColor: "#4940E5",
      });
    }
  };

  const handleChangeInput = (e) => {
    const code = e.keyCode;
    if ((code >= 48 && code <= 57) || code === 8 || code === 9) {
      return;
    } else {
      e.preventDefault();
    }
  };

  return (
    <div className="app_container">
      <div className="row w-100 m-0 h-100">
        <div className="col-12 col-lg-7 main_container">
          <div className="main_container_logo">
            <img src={Logo} alt="Logo Geodis" />
          </div>
          <div className="main_container_fecha">
            <img src={Fecha} alt="Fecha Geodis" />
          </div>
        </div>
        <div className="col-12 col-lg-5 form_container">
          <form onSubmit={handleSubmit(onSubmit)}>
            <h1>KEEP RISING</h1>
            <img
              src={Title}
              alt="Confirmación de Asistencia"
              className="title_img"
            />
            <div className="form_container_input_list">
              <div className="form_container_input">
                <div className="form_container_input_select"></div>
                <input
                  type="text"
                  placeholder="- NOMBRE Y APELLIDO -"
                  {...register("names")}
                />
              </div>
              {errors?.names?.type === "required" && <p>Ingrese un nombre.</p>}
              {errors?.names?.type === "max" && (
                <p>El nombre no debe exceder de 150 caracteres.</p>
              )}
              <div className="form_container_input">
                <div className="form_container_input_select"></div>
                <input
                  type="text"
                  placeholder="- DNI -"
                  {...register("dni")}
                  maxLength="8"
                  onKeyDownCapture={handleChangeInput}
                />
              </div>
              {errors?.dni?.type === "required" && <p>Ingrese un DNI.</p>}
              {errors?.dni?.type === "max" && (
                <p>El DNI no debe tener más de 8 dígitos.</p>
              )}
              <div className="form_container_input">
                <div className="form_container_input_select"></div>
                <input
                  type="text"
                  placeholder="- CORREO ELECTRÓNICO -"
                  {...register("email")}
                />
              </div>
              {errors?.email?.type === "required" && <p>Ingrese un email</p>}
              {errors?.email?.type === "email" && (
                <p>Ingrese un email válido</p>
              )}
              {errors?.email?.type === "max" && (
                <p>El Email no debe tener más de 100 caracteres.</p>
              )}
              <div className="form_container_input">
                <div className="form_container_input_select"></div>
                <input
                  type="text"
                  placeholder="- CELULAR -"
                  {...register("phone")}
                  maxLength="12"
                  onKeyDown={handleChangeInput}
                />
              </div>
              {errors?.phone?.type === "required" && (
                <p>Ingrese un teléfono.</p>
              )}
              {errors?.phone?.type === "max" && (
                <p>El número no debe tener más de 12 dígitos.</p>
              )}
              <div className="form_container_input">
                <div className="form_container_input_select"></div>
                <input
                  type="text"
                  placeholder="- EMPRESA -"
                  {...register("company")}
                  maxLength="100"
                />
              </div>
              {errors?.company?.type === "required" && (
                <p>Ingrese la empresa</p>
              )}
              {errors?.company?.type === "max" && (
                <p>El empresa no debe tener más de 100 caracteres.</p>
              )}
            </div>
            <button
              type="submit"
              className={isLoading ? "button_disabled" : ""}
              disabled={isLoading}
            >
              <div className="button_white">
                <p>ENVIAR</p>
                <img src={Arrow} alt="" />
              </div>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default App;
